export const authorSearchConstants = {
    ALL: 'AUTHOR_ALL_IN',
    GET_DAY:'GET_NOW_DATE',
    SET_TIME_STATUS:'SET_TIME_STATUS',
    A_KEY:'AUTHOR_KEY',
    A_NAME:'AUTHOR_NAME',
    SET_DOCS:'SET_ALLDOCS',
    REQUEST_AUTHOR:'SEARCH_AUTHOR_NAME_REQUEST',
    RECEIVE_AUTHOR:"RECEIVE_AUTHOR_DATA",
    REQUEST_AUTHOR_ANALYSIS:'REQUEST_AUTHOR_ANALYSIS_DATA',
    RECEIVE_AUTHOR_ANALYSIS:'RECEIVE_AUTHOR_ANALYSIS_DATA',
    REQUEAT_SUNBURST:'REQUEAT_AUTHOR_SUNBURST',
    RECEIVE_SUNBURST:'RECEIVE_AUTHOR_SUNBURST',
    SWITCH_TYPE:"SWITCH_SEARCH_TYPE",
};



// WEBPACK FOOTER //
// ./src/constants/authorSearch.constants.js